module.exports = __webpack_public_path__ + "static/moonwalking-with-einstein-106d52b570f1b041e72e8a56be91dad6.jpg";